module.exports = __webpack_public_path__ + "static/media/git.135a825e.svg";